import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

function GanttFinanceiroProjeto({ projeto, valorGasto }) {
  if (!projeto) return <div>Carregando gráfico financeiro...</div>;

  // --- LÓGICA DE VALOR ALINHADA COM O RESTO DO SISTEMA ---
  const valorLicitado = parseFloat(projeto.valor_licitado) || 0;
  const valorRepasse = parseFloat(projeto.valor_repasse) || 0;
  const valorContrapartida = parseFloat(projeto.valor_contrapartida) || 0;

  // Se houver valor_licitado > 0, ele será a base.
  // Caso contrário, usa a soma de repasse + contrapartida
  const valorTotal =
    valorLicitado > 0 ? valorLicitado : valorRepasse + valorContrapartida;

  const gasto = parseFloat(valorGasto) || 0;
  const valorRestante = Math.max(0, valorTotal - gasto);

  // --- CÁLCULO DA PORCENTAGEM PARA O CENTRO ---
  const percentualGasto =
    valorTotal > 0 ? Math.round((gasto / valorTotal) * 100) : 0;

  const data = {
    labels: ["Valor Gasto", "Valor Restante"],
    datasets: [
      {
        data: [gasto, valorRestante],
        backgroundColor: [
          "rgba(46, 204, 113, 0.7)", // Gasto (Verde)
          "rgba(52, 152, 219, 0.3)", // Restante (Azul claro)
        ],
        hoverBackgroundColor: [
          "rgba(46, 204, 113, 0.9)",
          "rgba(52, 152, 219, 0.5)",
        ],
        borderColor: ["rgba(46, 204, 113, 1)", "rgba(52, 152, 219, 0.5)"],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "75%", // Aumentei o espaço interno para o texto caber melhor
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          font: { size: 14, family: "'Poppins', sans-serif", weight: "500" },
          padding: 20,
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
      tooltip: {
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        titleColor: "#2c3e50",
        titleFont: { size: 16, family: "'Poppins', sans-serif", weight: "600" },
        bodyColor: "#2c3e50",
        bodyFont: { size: 14, family: "'Poppins', sans-serif" },
        borderColor: "#e1e8ed",
        borderWidth: 1,
        padding: 12,
        callbacks: {
          label: function (context) {
            return `${context.label}: R$ ${context.raw.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}`;
          },
        },
      },
    },
  };

  return (
    <div
      style={{
        height: "350px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "relative",
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* Gráfico */}
        <Doughnut data={data} options={options} />

        {/* --- TEXTO NO CENTRO DO GRÁFICO --- */}
        <div
          style={{
            position: "absolute",
            top: "43%", // 43% porque a legenda embaixo empurra o gráfico um pouco para cima
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            pointerEvents: "none", // IMPORTANTÍSSIMO: Evita que o texto bloqueie o hover/tooltip do gráfico
          }}
        >
          <div
            style={{
              fontSize: "2.5rem",
              fontWeight: "bold",
              color: "#2c3e50",
              lineHeight: "1",
            }}
          >
            {percentualGasto}%
          </div>
          <div
            style={{
              fontSize: "0.9rem",
              color: "#7f8c8d",
              fontWeight: "500",
              marginTop: "5px",
            }}
          >
            Executado
          </div>
        </div>
      </div>
    </div>
  );
}

export default GanttFinanceiroProjeto;
